import { ISnotrRoute } from '..';

export default [
  {
    path: '/altinn-reports',
    name: 'Ameldings',
    meta: {
      title: 'TabTitle.ameldings',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/Amelding/ameldings.vue'),
  },
  {
    path: '/altinn-reports/new',
    name: 'NewAmeldings',
    meta: {
      title: 'TabTitle.newAmeldings',
      applicationMode: 'PaycheckMode',
    },
    props: route => ({
      year: route.query.year,
      ameldingToReplaceId: route.query.ameldingToReplaceId,
    }),
    component: () => import('@/pages/AmeldingNew/ameldings-new.vue'),
  },
  {
    path: '/altinn-reports/tax-deduction',
    name: 'TaxDeductionToPay',
    meta: {
      title: 'TabTitle.taxes',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/Amelding/TaxDeductionToPay.vue'),
  },
  {
    path: '/altinn-reports/taxes',
    name: 'AltinnTaxInvoicePreviews',
    meta: {
      title: 'TabTitle.altinnTaxPreview',
      applicationMode: 'PaycheckMode',
    },
    props: route => ({
      calendarMonth: route.query.month,
    }),
    component: () => import('@/pages/AltinnTaxInvoicePreviews/altinn-tax-invoice-previews.vue'),
  },
  {
    path: '/altinn-reports/:id',
    name: 'AmeldingsShow',
    meta: {
      title: 'TabTitle.showAmeldings',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/Amelding/ameldings-show.vue'),
  },
] as ISnotrRoute[];
